<template>
  <CommonSimpleRow
    v-for="scheduledEvent in scheduledEvents"
    :key="scheduledEvent.egId"
    class="common-simple-row-padding"
    :class="getCssClass(scheduledEvent, followingEvents)"
  >
    <!-- egId: {{ scheduledEvent.egId }} -->
    <ResultsScheduleCompEvent
      :store-comp-results-state="storeCompResultsState"
      :comp-event="scheduledEvent"
      :show-follow-event-setup="showFollowEventSetup"
      :is-following="followingEvents[scheduledEvent.egId]"
      @showDetails="showDetails"
      @shouldFollowEvent="shouldFollowEvent"
    />
  </CommonSimpleRow>
</template>

<script setup lang="ts">
import type {
  CompEvent,
  FollowingEvents,
  ShouldFollowEvent,
  StoreCompResultsState
} from '@/components/results/store-comp-results'
import { type PropType } from 'vue'
import {
  compEventHasHowManyEntries,
  compEventHasHowManyResultHeats
} from '@/components/results/results-service'

import * as ResultsService from '@/components/results/results-service'
import ResultsScheduleCompEvent from '@/components/results/schedule/ResultsScheduleCompEvent.vue'
import CommonSimpleRow from '@/common/ui/CommonSimpleRow.vue'

const props = defineProps({
  storeCompResultsState: {
    type: Object as PropType<StoreCompResultsState>,
    required: true
  },
  scheduledEvents: {
    type: Array as PropType<CompEvent[]>,
    required: true
  },
  showFollowEventSetup: {
    type: Boolean,
    default: false
  },
  followingEvents: {
    type: Object as PropType<FollowingEvents>,
    required: false,
    default: () => ({})
  }
})

//  define emits.
const emit = defineEmits<{
  (e: 'showDetails', value: CompEvent): void
  (e: 'showEntries', value: CompEvent): void
  (e: 'showResults', value: CompEvent): void
  (e: 'shouldFollowEvent', value: ShouldFollowEvent): void
}>()

function showDetails(compEvent: CompEvent) {
  console.log('showDetails event: ' + compEvent.name, compEvent)
  emit('showDetails', compEvent)
}

function showEntries(compEvent: CompEvent) {
  console.log('showEntries event: ' + compEvent.name, compEvent)
  emit('showEntries', compEvent)
}

function showResults(compEvent: CompEvent) {
  console.log('showResults event: ' + compEvent.name, compEvent)
  emit('showResults', compEvent)
}

function entryCount(scheduledEvent: CompEvent) {
  return compEventHasHowManyEntries(scheduledEvent)
}

function resultCount(scheduledEvent: CompEvent) {
  return compEventHasHowManyResultHeats(scheduledEvent)
}

function getEventTime(scheduledEvent: CompEvent) {
  return ResultsService.getCompEventStartTime(scheduledEvent)
}
function shouldFollowEvent(value: ShouldFollowEvent) {
  emit('shouldFollowEvent', value)
}

function getCssClass(scheduledEvent: CompEvent, followingEvents: FollowingEvents) {
  return ResultsService.getScheduledEventCss(scheduledEvent, followingEvents)
}
</script>

<style scoped>
.results-schedule--has-results-xxx {
  border-right: 3px solid var(--yellow-500);
}

.results-schedule--is-following-xxx {
  background: var(--green-100);
}
</style>
